if (!customElements.get('liene-discount-codes')) {
  customElements.define('liene-discount-codes', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('.ldc__copy');
        if (button && this.contains(button)) this.copy(button);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async copy(button) {
      const code = button.dataset.code;
      if (!code || button.disabled) return;
      const item = button.closest('.ldc__item');
      const status = item.querySelector('.ldc__status');
      const manual = item.querySelector('.ldc__manual');
      const original = button.dataset.label || button.textContent;
      button.dataset.label = original;
      button.disabled = true;
      status.textContent = '';
      status.dataset.state = '';
      manual.hidden = true;
      try {
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
        } catch (_) {
          const input = document.createElement('textarea');
          input.value = code;
          input.setAttribute('readonly', '');
          input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
          document.body.append(input);
          try {
            input.select();
            if (!document.execCommand('copy')) throw new Error('Copy failed');
          } finally {
            input.remove();
            button.focus({ preventScroll: true });
          }
        }
        button.textContent = this.dataset.success;
        status.textContent = this.dataset.success;
        status.dataset.state = 'success';
      } catch (_) {
        button.textContent = original;
        status.textContent = this.dataset.error;
        status.dataset.state = 'error';
        manual.hidden = false;
      } finally {
        button.disabled = false;
      }
    }
  });
}
